import React from 'react';
import { ArrowShortIcon } from '../icons/arrowShort.icon';

interface BackButtonProps {
  onClick: () => void;
  title: string;
  label?: string;
}

const BackButton: React.FC<BackButtonProps> = ( { onClick, title, label } ) => {
  const hasLabel = Boolean( label );
  const baseClasses = 'bg-orange-500 text-white hover:bg-orange-600 transition-colors duration-200 shadow-md';

  if ( hasLabel ) {
    return (
      <button
        onClick={onClick}
        className={`${baseClasses} inline-flex items-center gap-2 px-3 py-2 rounded-md m-2`}
        title={title}
        aria-label={title}
      >
        <ArrowShortIcon className="transform rotate-180" size={5} />
        <span className="text-sm font-medium truncate">{label}</span>
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className={`${baseClasses} w-10 h-10 rounded-full flex items-center justify-center m-4 mb-8`}
      title={title}
      aria-label={title}
    >
      <ArrowShortIcon className="transform rotate-180" size={5} />
    </button>
  );
};

export default BackButton;
